
import React from 'react';

export const GridViewIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    grid_view
  </span>
);